import Config from "src/Constants/Config";
import Home from "src/Pages/Home";

const DATA_INTRO = {
  bgImage: `${Config.BASE_URL}/images/intro/home.png`,
  children: <Home />,
};

export default DATA_INTRO;
